import { LogoutTimer } from '@/components/Menu/User/LogoutTimer'
import { ChangePasswordModal } from '@/containers/auth/change-password/ChangePasswordModal'
import { useAuth } from '@/context/AuthContext'
import { LogoutTimerProvider } from '@/context/LoginTimerProvider'
import { useDisclosure } from '@chakra-ui/react'
import { useEffect, useRef } from 'react'
import { Outlet } from 'react-router-dom'
import { WithAuth } from '../hoc/WithAuth'

const AuthLayoutComponent = () => {
  const { user } = useAuth()
  const disclosure = useDisclosure()
  const changePasswordPrompted = useRef(false)

  useEffect(() => {
    if (user?.mustChangePassword && !changePasswordPrompted.current) {
      disclosure.onOpen()
      changePasswordPrompted.current = true
    }
    else if (!user?.mustChangePassword && changePasswordPrompted.current) {
      disclosure.onClose()
      changePasswordPrompted.current = false
    }
  }, [disclosure, user?.mustChangePassword])

  return (<LogoutTimerProvider>
    <LogoutTimer />
    <ChangePasswordModal {...disclosure} 
      closeable={false}
      description="Z bezpečnostních důvodů je vyžadována změna hesla. Prosím nastavte si nové heslo pro pokračování." />
    <Outlet />
  </LogoutTimerProvider>)
}

export const AuthLayout = WithAuth(AuthLayoutComponent)
